import { localeConfigurations } from './FormatDate.const'
import { DateFormatOptions } from './FormatDate.types'

export const getFormattedDate = (locale: string | Array<string>, scheduledStartTime: string, isShort: boolean) => {
  const extractLocale: string = Array.isArray(locale) && locale.length > 0 ? locale[0] : locale ? locale  as string : 'en-GB'
  const language: string = extractLocale.split('-')?.[0]?.toLowerCase() || 'en'
  const config: DateFormatOptions = localeConfigurations.hasOwnProperty(language) && localeConfigurations[language] as DateFormatOptions || localeConfigurations.en
  const date: Date = new Date(scheduledStartTime)
  const options = isShort ? config.short : config.default

  return new Intl.DateTimeFormat(config.locales, options).format(date)
}